import classes from './Home.module.css'
import bannerImg from '../assets/banner.jpg'

function Home(){
    return (
      <div
        className={classes.hero}
        style={{ backgroundImage: `url(${bannerImg})` }}
      >
        <div className={classes.overlay}>
          <div className={classes.heroContent}>
            <p className={classes.tagline}>Premium Furniture &amp; Interior Fit-out</p>
            <h1 className={classes.headline}>Bringing Dreams to Life</h1>
            <p className={classes.subtext}>
              Bespoke joinery, upholstery &amp; full interior contracting across the UAE
            </p>
            <div className={classes.heroCta}>
              <a href="/services" className={classes.ctaBtn}>Our Services</a>
              <a href="/contact-us" className={classes.ctaBtnOutline}>Get in Touch</a>
            </div>
          </div>
        </div>
      </div>
    );
}

export default Home;